import { FragmentType } from '../interfaces/Publication';

export const translateFragmentType = (fragmentType: string) => {
  switch (fragmentType) {
    case FragmentType.TABLE:
        return 'Tabla';
    case FragmentType.INF:
        return 'Infografía';
    case FragmentType.OVA:
        return 'Figura';
    case FragmentType.GAL:
        return 'Galería';
    case FragmentType.VIDEO:
        return 'Video';
    default:
        return '';
  }
}